import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { PaginationDots } from '@elseu/sdu-titan';
import React, { useRef, useState, useEffect } from 'react';
import styled, { css } from 'styled-components';

var StyledSlider = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  width: 100%;\n\n  ::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n"], ["\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  width: 100%;\n\n  ::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n"])));
var StyledSlide = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var align = _a.align,
    theme = _a.theme;
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: none;\n    scroll-snap-align: start;\n    width: 100%;\n    align-self: ", ";\n    margin: 0 ", ";\n  "], ["\n    flex: none;\n    scroll-snap-align: start;\n    width: 100%;\n    align-self: ", ";\n    margin: 0 ", ";\n  "])), align, theme.spacing[2]);
});
/**
 * Slider component for sliding through a list of elements
 * @component
 * @param {object} props
 * @param {React.ReactNode} props.children - The list of elements to slide through
 */
var Slider = function (_a) {
  var children = _a.children,
    align = _a.align;
  var totalSlides = React.Children.count(children);
  var slidesRef = useRef([]);
  var _b = useState(1),
    currentSlide = _b[0],
    setCurrentSlide = _b[1];
  /**
   * Function to handle the slide change when a new slide is selected
   * @param {number} number - The index of the slide to change to
   */
  var handleSlideChange = function (number) {
    var slideElement = slidesRef.current[number - 1];
    var containerElement = slideElement.parentNode;
    var scrollLeft = slideElement.offsetLeft - containerElement.offsetLeft;
    containerElement.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };
  /* Initialize the IntersectionObserver to detect when slides become visible */
  useEffect(function () {
    var options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var index = slidesRef.current.indexOf(entry.target);
          setCurrentSlide(index + 1);
        }
      });
    }, options);
    slidesRef.current.forEach(function (slideRef) {
      observer.observe(slideRef);
    });
    return function () {
      observer.disconnect();
    };
  }, [totalSlides]);
  return jsxs(Fragment, {
    children: [jsx(StyledSlider, {
      children: React.Children.map(children, function (child, index) {
        return jsx(StyledSlide
        // eslint-disable-next-line react/no-array-index-key
        , {
          align: align,
          ref: function (element) {
            if (element instanceof HTMLLIElement) {
              slidesRef.current[index] = element;
            }
          },
          children: child
        }, index);
      })
    }), totalSlides > 1 && jsx(PaginationDots, {
      totalPages: totalSlides,
      currentPage: currentSlide,
      onPageChange: function (number) {
        return handleSlideChange(number);
      },
      labelPagePrev: "Vorige",
      labelPageNext: "Volgende"
    })]
  });
};
Slider.defaultProps = {
  align: 'center'
};
var templateObject_1, templateObject_2, templateObject_3;

export { Slider };
//# sourceMappingURL=Slider.js.map
